webpackJsonp([74],{

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(822);


/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(568);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1622]);


// WEBPACK FOOTER //
// app/datetime.it-6e67d07bd020f9da98d4.js